import React from "react";
import styles from "./initialsAvatar.css";

interface Props {
  name: string;
  className?: string;
}

export const InitialsAvatar = (props: Props) => (
  <div className={[styles.avatar].concat(props.className ? [props.className] : []).join(" ")}>
    {props.name
      .split(" ")
      .filter((e) => e.length > 0)
      .slice(0, 2)
      .map((e) => e[0])
      .join("")
      .toUpperCase()}
  </div>
);
